export default "__VITE_ASSET__CWLI6PvW__"